import {
  TRAFFIC_FROM_ADS_OPTION,
  TOTAL_VISITS_OPTION,
  AD_VISITS_OPTION,
  NEW_AD_USERS_OPTION,
  TOTAL_ADS_OPTION,
  AVG_AD_COST,
  NEW_USER_SESSIONS,
  ON_AIR_LIFT_OPTION
} from '../../../../../components/DashBoardAnalyzeHeader/constants';

export const initialSnapshots = [
  {
    id: 'liftSnapshot',
    showInReport: false,
    name: 'Lift',
    value: TRAFFIC_FROM_ADS_OPTION,
    descriptionTitle: 'Lift',
    descriptionText: '% of Ad Visits / Non Ad Visits',
    backgroundColor: '#78B6D8'
  },
  {
    id: 'dualLiftSnapshot',
    showInReport: false,
    name: 'Lift',
    value: TRAFFIC_FROM_ADS_OPTION,
    descriptionTitle: 'Lift',
    backgroundColor: '#78B6D8',
    customOptions: [
      {
        id: 'campaignLift',
        name: 'Campaign Lift',
        showInReport: false
      },
      {
        id: 'industryAverage',
        name: 'Industry Average',
        showInReport: false
      }
    ],
    stayInSidebar: true
  },
  {
    id: 'visitsSnapshot',
    showInReport: false,
    name: 'Visits',
    value: TOTAL_VISITS_OPTION,
    descriptionTitle: 'Visits',
    descriptionText: 'Visits on a website or app',
    backgroundColor: '#6794DC'
  },
  {
    id: 'adVisitsSnapshot',
    showInReport: false,
    name: 'Ad Visits',
    value: AD_VISITS_OPTION,
    descriptionTitle: 'Ad Visits',
    descriptionText: 'Visits after an ad airs within the attribution window',
    backgroundColor: '#6771DC'
  },
  {
    id: 'adUsersSnapshot',
    name: 'New Ad Users',
    showInReport: false,
    value: NEW_AD_USERS_OPTION,
    descriptionTitle: 'New Ad Users',
    descriptionText: 'Unique new users post-ad within attribution window',
    backgroundColor: '#8067DC'
  },
  {
    id: 'dualNewUsersSnapshot',
    name: 'New Users',
    showInReport: false,
    value: NEW_USER_SESSIONS,
    descriptionTitle: 'New Users',
    descriptionText: 'Include both Total New Users and New Ad Users value',
    backgroundColor: '#8067DC'
  },
  {
    id: 'userSessionSnapshot',
    name: 'New User Sessions',
    showInReport: false,
    value: NEW_USER_SESSIONS,
    descriptionTitle: 'New User Sessions',
    descriptionText:
      'First-time visits to a website within the entire campaign time period',
    backgroundColor: '#8067DC'
  },
  {
    id: 'totalAdsSnapshot',
    showInReport: false,
    name: 'Total Ads',
    value: TOTAL_ADS_OPTION,
    descriptionTitle: 'Total Ads',
    descriptionText: '# of Spots or Live Reads detected',
    backgroundColor: '#A367DC'
  },
  {
    id: 'avgAdCostSnapshot',
    showInReport: false,
    name: 'Avg. Ad Cost',
    value: AVG_AD_COST,
    descriptionTitle: 'Avg. Ad Cost',
    descriptionText: 'Total Cost reported to Veritone / Total Ads',
    backgroundColor: '#C767DC'
  }
];

export const initialSnapshotsAlphaMedia = [
  {
    id: 'onAirLiftSnapshot',
    showInReport: false,
    name: 'On Air Lift',
    value: ON_AIR_LIFT_OPTION,
    descriptionTitle: 'On Air Lift',
    descriptionText:
      'Percent increase or decrease of average web visits for on air days',
    backgroundColor: '#67B7DC'
  },
  {
    id: 'visitsSnapshot',
    showInReport: false,
    name: 'Visits',
    value: TOTAL_VISITS_OPTION,
    descriptionTitle: 'Visits',
    descriptionText: 'Visits on a website or app',
    backgroundColor: '#55A6D4'
  },
  {
    id: 'adVisitsSnapshot',
    showInReport: false,
    name: 'Ad Visits',
    value: AD_VISITS_OPTION,
    descriptionTitle: 'Ad Visits',
    descriptionText: 'Visits after an ad airs within the attribution window',
    backgroundColor: '#6794DC'
  },
  {
    id: 'adUsersSnapshot',
    name: 'New Ad Users',
    showInReport: false,
    value: NEW_AD_USERS_OPTION,
    descriptionTitle: 'New Ad Users',
    descriptionText: 'Unique new users post-ad within attribution window',
    backgroundColor: '#6771DC'
  },
  {
    id: 'dualNewUsersSnapshot',
    name: 'New Users',
    showInReport: false,
    value: NEW_USER_SESSIONS,
    descriptionTitle: 'New Users',
    descriptionText: 'Include both Total New Users and New Ad Users value',
    backgroundColor: '#6771DC'
  },
  {
    id: 'userSessionSnapshot',
    name: 'New User Sessions',
    showInReport: false,
    value: NEW_USER_SESSIONS,
    descriptionTitle: 'New User Sessions',
    descriptionText:
      'First-time visits to a website within the entire campaign time period',
    backgroundColor: '#6771DC'
  },
  {
    id: 'totalAdsSnapshot',
    showInReport: false,
    name: 'Total Ads',
    value: TOTAL_ADS_OPTION,
    descriptionTitle: 'Total Ads',
    descriptionText: '# of Spots or Live Reads detected',
    backgroundColor: '#8067DC'
  },
  {
    id: 'avgAdCostSnapshot',
    showInReport: false,
    name: 'Avg. Ad Cost',
    value: AVG_AD_COST,
    descriptionTitle: 'Avg. Ad Cost',
    descriptionText: 'Total Cost reported to Veritone / Total Ads',
    backgroundColor: '#A367DC'
  },
  {
    id: 'liftSnapshot',
    showInReport: false,
    name: 'Lift',
    value: TRAFFIC_FROM_ADS_OPTION,
    descriptionTitle: 'Lift',
    descriptionText: '% of Ad Visits / Non Ad Visits',
    backgroundColor: '#C767DC'
  },
  {
    id: 'dualLiftSnapshot',
    showInReport: false,
    name: ' Attribute Lift',
    value: TRAFFIC_FROM_ADS_OPTION,
    descriptionTitle: 'Lift',
    backgroundColor: '#C767DC',
    customOptions: [
      {
        id: 'campaignLift',
        name: 'Campaign Lift',
        showInReport: false
      },
      {
        id: 'industryAverage',
        name: 'Industry Average',
        showInReport: false
      }
    ],
    stayInSidebar: true
  }
];
